// Initialize GSAP animation
document.addEventListener('DOMContentLoaded', () => {
  // Only run on homepage
  if (document.body.classList.contains('template-index')) {
    // Get our elements
    const mainMenu = document.querySelector('.main-menu');
    const logoLink = mainMenu.querySelector('.logo-link');
    const pagesMenu = mainMenu.querySelector('.pages-menu');
    
    // Initial states - logo centered but 50px higher, menu hidden
    gsap.set(pagesMenu, {
      opacity: 0,
      position: 'fixed',
      top: '50%',
      left: '50%',
      xPercent: -50,
      yPercent: -50
    });
    
    gsap.set(logoLink, {
      position: 'fixed',
      top: '50%',
      left: '50%',
      xPercent: -50,
      yPercent: -50,
      y: -50, // Use y transform instead of changing top
      zIndex: 100,
      cursor: 'pointer'
    });
    
    // Create the animation timeline (paused initially)
    const tl = gsap.timeline({ paused: true });
    
    tl.to(logoLink, {
      top: '15%',
      y: 0, // Reset the y transform
      duration: 0.75,
      ease: 'power2.inOut'
    })
    .to(pagesMenu, {
      opacity: 1,
      duration: 0.75,
      ease: 'power2.in'
    }, '-=0.25');

    // Add click event to logo to trigger animation
    logoLink.addEventListener('click', (e) => {
      e.preventDefault(); // Prevent default link behavior initially
      
      // Play the animation
      tl.play();
      
      // After animation completes, restore normal link behavior
      tl.eventCallback('onComplete', () => {
        logoLink.style.cursor = 'default';
        // Remove the click event listener so logo works normally
        logoLink.removeEventListener('click', arguments.callee);
      });
    });
  }
}); 